@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

$title-height: 48px;
$popover-padding: 8px;

.popover {
  @include blur(35px);
  box-shadow: 0.5px 0.5px 0px 0px #fff inset, 0px 6px 32px 0px rgba(0, 0, 0, 0.15);
  background-color: var(--light-80);
  padding: $popover-padding $popover-padding 0 $popover-padding;
  width: 370px;
  max-height: 100vh !important;
  border-radius: 12px;
  margin-left: 4px;
}

.scrollContainer {
  @include hide-scrollbar;
  max-height: calc(70vh - $nav-bar-height - $title-height - $popover-padding);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;

  &.readHeader {
    padding: 0 0 8px 0;
  }
}

.titleContainer {
  display: flex;
  align-items: center;
  gap: 4px;
}

.infiniteScroll {
  display: flex;
  justify-content: center;
}

.section {
  @include md-semibold;
  color: var(--neutral-90);
  height: 20px;
  margin: 4px 0 4px 4px;
}

.triggerButton {
  position: relative;
}

.counter {
  position: absolute;
  right: 2px;
  z-index: 1;

  @include for-desktop-only {
    right: 0;
  }
}

.showArchived {
  margin: 10px 0;
}
